import { ContactPersonEndpoint } from './../../_proxy/endpoints/contactperson.endpoint';
import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { BaseDocument } from '@dato-proxy/entities/basedocument.entity';
import { PaymentRequest } from '@dato-proxy/entities/paymentrequest.entity';
import { EnumPaymentRequestStatuses, EnumPaymentRequestTypes } from '@dato-proxy/enums';
import { PaymentRequestEndpoint } from '@dato-proxy/endpoints/paymentrequest.endpoint';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { Component, ViewChild } from '@angular/core';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { PaymentRequestListParams } from '@dato-proxy/params/paymentrequestlist.param';
import { PaymentRequestStep } from '@dato-proxy/entities/paymentrequest.entity';
import { PaymentRequestGridComponent } from './Components/payment-request-grid/payment-request-grid.component';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';

class State extends BaseState {
    CustomerID: number;
    ContactPersonID: number;
    Statuses: EnumPaymentRequestStatuses[];
    DateFrom: Date;
    DateTo: Date;
    SumFrom: number;
    SumTo: number;
    Type: EnumPaymentRequestTypes;

    Steps: PaymentRequestStep[] = null;
    LinesDocuments: BaseDocument[] = null;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-payment-request-report',
    templateUrl: './payment-request-report.component.html',
    styleUrls: ['./payment-request-report.component.scss']
})
export class PaymentRequestReportComponent extends BasePageComponent<BaseEntity, State> {

    @ViewChild(PaymentRequestGridComponent) paymentRequestGrid: PaymentRequestGridComponent;

    constructor(A: ServiceBagService,
        private paymentRequestEndpoint: PaymentRequestEndpoint,
        private customerEndpoint: CustomerEndpoint,
        private contactPersonEndpoint: ContactPersonEndpoint) {
        super(A, 'PaymentRequestReportComponent', BaseEntity, State);
    }

    override OnInitComponent() {
        this.InitDataSource();
        this.InitCustomers();
    }

    override OnGetToolbarSettings() {
        const settings = new ToolbarSettings();
        settings.IsAllowFilter = true;
        settings.GridExtender = this.paymentRequestGrid?.G;

        return settings;
    }

    override OnApplyFilter() {
        this.InitDataSource();
    }

    override OnClearFilter() {
        this.State.CustomerID = undefined;
        this.State.ContactPersonID = undefined;
        this.State.Statuses = undefined;
        this.State.DateFrom = undefined;
        this.State.DateTo = undefined;
        this.State.SumFrom = undefined;
        this.State.SumTo = undefined;
        this.State.Type = undefined;

        this.InitDataSource();
    }

    OnPaymentRequestSelected(oPaymentRequest: PaymentRequest) {
        if (oPaymentRequest == undefined) return;
        this.Do(this.paymentRequestEndpoint.GetSteps(oPaymentRequest.EntryID), false, (response) => {
            this.State.Steps = response.Entities;
        });

        this.Do(this.paymentRequestEndpoint.GetLinesDocuments(oPaymentRequest.EntryID), false, (response) => {
            this.State.LinesDocuments = response.Entities;
        });
    }

    OnResolveClick(oPaymentRequest: PaymentRequest) {
        //let s = e;
        this.Do(this.paymentRequestEndpoint.ResolveStatus(oPaymentRequest.EntryID), false, (response) => {
            this.InitDataSource();
        });
    }

    InitDataSource() {
        this.State.Steps = null;
        this.State.LinesDocuments = null;

        const params = new PaymentRequestListParams();
        params.CustomerID = this.State.CustomerID;
        params.ContactPersonID = this.State.ContactPersonID;
        params.Statuses = this.State.Statuses;
        params.DateFrom = this.State.DateFrom;
        params.DateTo = this.State.DateTo;
        params.SumFrom = this.State.SumFrom;
        params.SumTo = this.State.SumTo;
        if (this.State.Type) { params.Types = [this.State.Type]; }

        this.DataSources['PaymentRequests'] = new DataSourceCustomAction((options: DataLoadOptions) => this.paymentRequestEndpoint.ListEx(params, options?.GetLoadOptions()), undefined, (data) => {
            if (this.State.Steps === null && data.length > 0) { this.OnPaymentRequestSelected(data[0]); }
        });
    }

    OnCustomerChanged() { this.InitContactPersons(); }

    private InitCustomers() {
        this.DataSources['Customers'] = new DataSourceCustomAction((options: DataLoadOptions) => this.customerEndpoint.List(options), (EntryID) => this.customerEndpoint.Get(EntryID));
    }

    private InitContactPersons() {
        if (!this.State.CustomerID) {
            this.DataSources['ContactPersons'] = [];
            return;
        }

        this.Do(this.contactPersonEndpoint.ListEx(this.State.CustomerID), false, (response) => {
            this.DataSources['ContactPersons'] = response.Entities;
        });

    }
}
